import { Controller } from "@hotwired/stimulus"

// Filtre client-side une liste d'elements par texte (attribut data-name).
// Usage :
//   <input data-controller="local-filter" data-local-filter-target-selector-value=".duplicate-group">
//   <div><div class="duplicate-group" data-name="acme sas">...</div></div>
export default class extends Controller {
  static values = { targetSelector: String }

  connect() {
    this.element.addEventListener("input", this.onInput)
    this.element.addEventListener("search", this.onInput)
  }

  disconnect() {
    this.element.removeEventListener("input", this.onInput)
    this.element.removeEventListener("search", this.onInput)
  }

  onInput = (event) => {
    const q = (event.target.value || "").trim().toLowerCase()
    const items = document.querySelectorAll(this.targetSelectorValue)
    items.forEach(el => {
      const haystack = (el.dataset.name || el.textContent || "").toLowerCase()
      el.style.display = (q === "" || haystack.includes(q)) ? "" : "none"
    })
  }
}
